import * as chatwork from '@libs/chatwork'
import * as backend from '@libs/backend'
import * as utils from '@libs/utils'
import * as logManager from '@managers/logManager'

// チャットワークに送るメッセージを生成するファイルです

/**
 * 自動雇い入れタスク登録の通知
 * @param {*} context 
 * @param {*} data 
 */
export async function autoEmployTaskChat(context, data) {
  // DCの場合、個人通知も行う
  if (!data.employmentRegularStaff) {
    await employmentDCChat(context, data._id, true, data)
  }
}

/**
 * DC雇い入れメインタスク登録時
 * @param {*} id メインタスクID
 * @param {*} newFlag 新規登録フラグ
 * @param {*} data メインタスクデータ
 */
export async function employmentDCChat(context, id, newFlag, data) {
  let msg = []
  try {
    console.log(data)
    if (data.employmentClass) {
      // チャット情報取得
      const res = await backend.searchData('chatworkData/getDCRetire', { userList: false })
      if (res.data.data) {
        let chat = res.data.data.chat
        // 同じルームID、apiトークンでまとめる
        let roomId = {}
        for (let i = 0; i < chat.length; i++) {
          const c = chat[i]
          if (!roomId[String(c.roomId) + c.apiToken]) {
            roomId[String(c.roomId) + c.apiToken] = { 'to': [], roomId: c.roomId, apiToken: c.apiToken }
          }
          roomId[String(c.roomId) + c.apiToken]['to'].push(`[To:${c.chatworkAccountId || ''}]${c.userName}さん`)
        }
        // メッセージ生成
        const ec = data.employmentClass[0]
        msg = []
        if (newFlag) {
          msg.push('雇い入れ（清掃員）メインタスクが新規登録されました。')
        } else {
          msg.push('雇い入れ（清掃員）メインタスクが更新されました。')
        }
        msg.push('')
        msg.push('＜' + ec + '＞')

        if (data.employmentHireDate) {
          msg.push('入社日：' + data.employmentHireDate)
        } else if (data.employmentRetirementDate) {
          let day = '退職日：'
          if (data.employmentClass[0] == '契約変更') {
            day = '変更日：'
          }
          msg.push(day + data.employmentRetirementDate)
        }
        msg.push('清掃員：' + data.employmentName)
        msg.push(`● メインタスク：${utils.getSystemOrigin()}${process.env.VUE_APP_PUBLICPATH}RequestPost?requestPostId=${id}&mode=1`)

        for (let i = 0; i < Object.keys(roomId).length; i++) {
          const r = Object.keys(roomId)
          const message =
            roomId[r].to.join('\r\n')
            + '[info][title]清掃員（' + ec + '）[/title]'
            + msg.join('\r\n')
            + '[/info]'

          await chatwork.sendChatWorkMssage(
            roomId[r].roomId,
            message,
            roomId[r].apiToken
          )
        }
      }
    }
  } catch (error) {
    // エラーになってもフロントには返さない
    errLog(context, 'メインタスク', 'DC雇い入れ登録しましたが、そのChatwork通知に失敗しました。\r\n' + msg.join('\r\n'))
  }
}

/**
 * チャットワークAPIトークン取得
 * @param {*} context 
 * @param {*} toDepartment 
 * @returns APIトークン、ROOMID
 */
// function getApiToken(context, toDepartment) {
//   if (context) {
//     // 部署リスト
//     const depList = context.$store.getters.departmentList
//     if (depList && depList.length) {
//       // APIトークン取得
//       const token = depList.find((row) => {
//         return row.name === toDepartment
//       })

//       if (token && token.chatworkApiToken) {
//         return { token: token.chatworkApiToken, roomId: token.chatworkRoomId }
//       }
//     }
//   }
//   return null
// }

/**
 * エラーログ登録
 * @param {*} from 画面名 
 * @param {*} msg メッセージ
 */
async function errLog(context, from, msg) {
  await logManager.recording(context, logManager.Loglevel.ERROR, from, 'Chatwork通知エラー', msg)
}